<template>
  <div>
    <!-- 修改订单 -->
    <a-drawer
        v-model:visible="orderShow"
        :closable="false"
        :destroyOnClose="true"
        :maskStyle="{ backgroundColor: 'inherit' }"
        :width="500"
        class="custom-class"
        placement="right"
    >
      <div class="order-box">
        <div class="det-head">
          <div class="det-title">修改订单</div>
          <div class="f-20 f-c-999 close" @click="orderShow = false">
            <close-outlined/>
          </div>
        </div>
        <div>
          <div class="box-house">
            <div class="house-title">
              <div class="title_img">
                <a-image
                    :src="imgCut(houseInfo.image || companyInfo.logo, 's')"
                    fit="fill"
                    style="width: 100px; height: 70px"
                />
              </div>
              <div class="title_name">
                <div class="room-info" @click="showSelectRoom = true">
                  <div>{{ houseInfo.name || "请选择房间" }}</div>
                  <div>
                    <down-outlined/>
                  </div>
                </div>
              </div>
            </div>
            <div class="house-date">
              <div class="date-time">
                <div class="time-top">
                  <!-- {{ selHouse[0] }} -->
                  <a-date-picker
                      :allowClear="false"
                      :disabledDate="disableStime"
                      :value="selStime"
                      valueFormat="YYYY-MM-DD"
                      @change="stimeChange"
                  />
                </div>
                <div class="time-bom">
                  {{
                    "周" + "日一二三四五六".charAt(new Date(selStime).getDay())
                  }}入住
                </div>
              </div>
              <div class="date-night">
                <span>共</span>
                <span style="color: #dd0054; font-weight: bold">{{
                    diffDate(selStime, selEtime).length - 1
                  }}</span>
                <span>晚</span>
              </div>
              <div class="date-time">
                <div class="time-top">
                  <!-- {{
                dayjs(selHouse[selHouse.length - 1])
                  .add(1, "day")
                  .format("YYYY-MM-DD")
              }} -->
                  <a-date-picker
                      :allowClear="false"
                      :disabledDate="disableEtime"
                      :value="selEtime"
                      valueFormat="YYYY-MM-DD"
                      @change="etimeChange"
                  />
                </div>
                <div class="time-bom">
                  {{
                    "周" + "日一二三四五六".charAt(new Date(selEtime).getDay())
                  }}离店
                </div>
              </div>
            </div>
          </div>
          <div class="box-info">
            <div class="info-title">订单信息</div>
            <div class="info-form">
              <a-form
                  ref="orderRef"
                  :hideRequiredMark="true"
                  :label-col="{ span: 5 }"
                  :model="orderForm"
                  :wrapper-col="{ span: 17 }"
                  autocomplete="off"
                  labelAlign="left"
              >
                <a-form-item
                    :rules="[{ required: true, message: '请选择来源' }]"
                    label="来源"
                    name="origin"
                >
                  <a-select
                      v-model:value="orderForm.origin"
                      placeholder="请选择来源"
                  >
                    <a-select-option
                        v-for="item in searchList.source?.list"
                        :key="item.id"
                        :value="item.id"
                    >{{ item.name }}
                    </a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                    v-if="orderForm.origin != 1"
                    label="单号"
                    name="orderNum"
                >
                  <a-input
                      v-model:value="orderForm.orderNum"
                      allowClear
                      placeholder="来源平台单号（选填）"
                  />
                </a-form-item>
                <a-form-item label="房费" name="housePrice">
                  <a-input
                      v-model:value="orderForm.housePrice"
                      allowClear
                      placeholder="房费（选填）"
                  />
                </a-form-item>
                <a-form-item label="佣金" name="commission">
                  <a-input
                      v-model:value="orderForm.commission"
                      allowClear
                      placeholder="佣金（选填）"
                  />
                </a-form-item>
                <a-form-item
                    :rules="[{ required: true, message: '请输入押金' }]"
                    label="押金"
                    name="cash"
                >
                  <a-input
                      v-model:value="orderForm.cash"
                      allowClear
                      placeholder="押金，0则免押"
                  />
                </a-form-item>
                <a-form-item
                    :rules="[{ required: true, message: '请选择收款方式' }]"
                    label="收款方式"
                    name="payeeMode"
                >
                  <a-select
                      v-model:value="orderForm.payeeMode"
                      placeholder="请选择收款方式"
                  >
                    <a-select-option
                        v-for="item in searchList.paytype?.list"
                        :key="item.id"
                        :value="item.id"
                    >{{ item.name }}
                    </a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item label="备注" name="remark">
                  <a-textarea
                      v-model:value="orderForm.remark"
                      :rows="4"
                      allowClear
                      placeholder="备注信息"
                  />
                </a-form-item>
              </a-form>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <a-button :loading="loading" type="primary" @click="handleSaves"
        >保存
        </a-button
        >
        <a-button style="margin-left: 8px" @click="handleCancel">关闭</a-button>
      </template>
    </a-drawer>
    <SelectRoom
        v-model:visible="showSelectRoom"
        :endDate="selEtime"
        :startDate="selStime"
        @change="changeRoom"
    ></SelectRoom>
  </div>
</template>

<script>
import {reactive, toRefs, watch} from "vue";
import {getOrderDetail, getSearchList, houseDetails, orderEdit,} from "@/api/api";
import {verifyIdcard, verifyPhone, verifyPrice} from "@/common/validator";
import dayjs from "dayjs";
import useUtils from "@/hooks/useUtils.js";
import {message} from "ant-design-vue";
import {CloseOutlined, DownOutlined} from "@ant-design/icons-vue";
import SelectRoom from "../SelectRoom/SelectRoom.vue";

export default {
  name: "edit-order",
  components: {
    CloseOutlined,
    SelectRoom,
    DownOutlined,
  },
  props: {
    orderId: {
      type: [Number, String],
      required: true,
    },
    visible: {
      default: false,
      required: true,
    },
  },
  emits: ["update:visible", "refresh"],
  setup(props, {emit}) {
    const {imgCut, diffDate} = useUtils();

    const room = reactive({
      showSelectRoom: false,
      changeRoom(e) {
        orders.houseInfo = e;
      },
    });

    const orders = reactive({
      companyInfo: JSON.parse(sessionStorage.getItem("companyInfo")),
      orderInfo: props.params,
      orderRef: "",
      orderForm: {
        origin: 1,
        orderNum: "",
        housePrice: "",
        commission: "",
        cash: "",
        payeeMode: [100],
        remark: "",
      },
      selStime: dayjs().format("YYYY-MM-DD"),
      selEtime: dayjs().add(1, "day").format("YYYY-MM-DD"),
      nights: 1,
      houseInfo: "",
      orderShow: false,
      bodyStyle: {
        padding: "0",
      },
      // 不可选开始时间
      disableStime(date) {
        return date && date >= dayjs(orders.selEtime);
      },
      // 不可选结束时间
      disableEtime(date) {
        return date && date <= dayjs(orders.selStime);
      },
      // 开始时间 回调
      stimeChange(v, s) {
        orders.selStime = s;
      },
      // 结束时间 回调
      etimeChange(v, s) {
        orders.selEtime = s;
      },
      // 保存
      handleSaves() {
        orders.orderRef.validate().then(() => {
          inits.loading = true;
          orderEdit({
            hid: orders.houseInfo.id,
            start_date: orders.selStime,
            end_date: orders.selEtime,
            source_id: orders.orderForm.origin.toString(),
            paytype_id: orders.orderForm.payeeMode.toString(),
            total_amount: orders.orderForm.housePrice,
            royalty: orders.orderForm.commission,
            deposit: orders.orderForm.cash,
            remark: orders.orderForm.remark,
            out_trade_no: orders.orderForm.orderNum,
            order_id: props.orderId,
          })
              .then((res) => {
                orders.orderRef.resetFields();
                message.success(res.msg);
                orders.handleCancel();
                emit("refresh");
              })
              .finally(() => {
                inits.loading = false;
              });
        });
      },
      // 关闭
      handleCancel() {
        orders.orderShow = false;
      },
    });

    // 初始化
    const inits = reactive({
      loading: false,
      searchList: [],
      houseList: [],
      getSearch() {
        // 获取查询参数列表
        getSearchList().then((res) => {
          inits.searchList = res.data;
          orders.orderForm.cash = res.data.deposit?.list[0].num || "";
        });
      },
      // 获取房间详情
      getHouseDet() {
        houseDetails({
          hid: orders.hid,
        }).then((res) => {
          orders.houseInfo = res.data;
        });
      },
      // 获取订单详情
      getOrderDetails() {
        getOrderDetail({
          order_id: props.orderId,
        }).then((res) => {
          orders.selStime = res.data.order_details.start_date;
          orders.selEtime = res.data.order_details.end_date;
          orders.nights = res.data.order_details.nights;
          orders.hid = Number(res.data.order_details.hid);
          inits.getHouseDet();
          orders.orderForm.origin = [res.data.order_details.source_id];
          orders.orderForm.orderNum = res.data.order_details.out_trade_no;
          orders.orderForm.housePrice = res.data.order_details.total_amount;
          orders.orderForm.commission = res.data.order_details.royalty;
          orders.orderForm.cash = res.data.order_details.deposit;
          orders.orderForm.payeeMode = [res.data.order_details.paytype_id];
          orders.orderForm.remark = res.data.order_details.company_remark;
        });
      },
    });

    watch(
        () => props.visible,
        (n) => {
          if (n) {
            orders.orderShow = true;
            inits.getSearch();
            inits.getOrderDetails();
          } else {
            orders.orderShow = false;
          }
        }
    );

    watch(
        () => orders.orderShow,
        (value) => {
          emit("update:visible", value);
        }
    );

    return {
      verifyPhone,
      verifyIdcard,
      verifyPrice,
      imgCut,
      dayjs,
      diffDate,
      ...toRefs(inits),
      ...toRefs(orders),
      ...toRefs(room),
    };
  },
};
</script>

<style lang="scss" scoped>
// 录入订单
.order-box {
  // margin-top: 24px;
  .det-head {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f2f2f2;
    width: 100%;

    .det-title {
      color: #000000d9;
    }

    .close {
      cursor: pointer;

      &:hover {
        color: #000000;
      }
    }
  }

  .box-house {
    margin-bottom: 10px;
    background-color: #ffffff;

    .house-title {
      padding: 20px 0;
      font-weight: bold;
      border-bottom: 1px solid #f3f3f3;
      display: flex;
      // align-items: center;
      .title_img {
        // border-radius: 4px;
        overflow: hidden;
        margin-right: 10px;
        width: 100px;
      }

      .title_name {
        .room-info {
          background-color: #fff;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
          display: flex;
          min-width: 200px;
          min-height: 32px;
          cursor: pointer;
          justify-content: space-between;
          align-items: center;
          padding: 0 11px;

          &:hover {
            border: 1px solid #1890ff;
          }
        }
      }
    }

    .house-date {
      padding: 20px 0 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .date-time {
        text-align: center;

        .time-top {
        }

        .time-bom {
          color: #999;
        }
      }

      .date-night {
        border: 1px solid #f3f3f3;
        border-radius: 4px;
        padding: 2px 8px;

        span {
          padding: 0 2px;
        }
      }
    }
  }

  .box-person {
    margin-bottom: 10px;
    background-color: #ffffff;

    .person-title {
      border-bottom: 1px solid #f3f3f3;
      display: flex;
      justify-content: space-between;
      padding: 10px 0;

      .title-left {
        font-weight: bold;
      }

      .title-right {
        cursor: pointer;
        color: #0094ff;
      }
    }

    .person-list {
      .list_cont {
      }

      .list_inp {
        padding: 20px 5px;

        .person_add {
          cursor: pointer;
          display: flex;
          justify-content: center;

          .add_confirm {
            background-color: #0094ff;
            color: #fff;
            border-radius: 4px;
            padding: 2px 10px;
            margin-right: 10px;
          }

          .add_cancel {
            background-color: #f3f3f3;
            border-radius: 4px;
            padding: 2px 10px;
          }
        }
      }

      padding: 0 10px;

      .list-cell {
        display: flex;
        padding: 3px 0;

        .cell-name {
          flex: 3;
        }

        .cell-phone {
          flex: 4;
        }

        .cell-oper {
          flex: 3;
          text-align: right;

          span {
            padding: 0 3px;
          }

          .oper-del {
            cursor: pointer;
            color: #dd0054;
          }

          .oper-edit {
            cursor: pointer;
            color: #0094ff;
          }
        }
      }
    }
  }

  .box-info {
    background-color: #fff;
    padding-bottom: 5px;

    .info-title {
      border-bottom: 1px solid #f3f3f3;
      padding: 10px 0;
      font-weight: bold;
    }

    .info-form {
      padding: 20px 0;
    }
  }
}
</style>
